export const getCurrencySymbol = (currencyCode: string, locale?: string): string | undefined => {
    try {
        if(!locale || locale === '') {
            locale = getLocales({})[0]
        }
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 0, // Set to 0 to avoid displaying decimal places
            maximumFractionDigits: 0, // Set to 0 to avoid displaying decimal places
        });

        // Format a dummy value to extract the symbol
        const formattedParts = formatter.formatToParts(0);

        // Find the part with type 'currency'
        const currencyPart = formattedParts.find(part => part.type === 'currency');

        return currencyPart ? currencyPart.value : undefined;
    } catch (error) {
        console.error(`Error getting currency symbol for ${currencyCode}:`, error);
        return '$';
    }
}

export const getLocales = (options: object) => {
      const defaultOptions = {
    languageCodeOnly: false,
  };
  const opt = {
    ...defaultOptions,
    ...options,
  };
  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages;
  if (!browserLocales) {
    return ["en-US"];
  }
  return browserLocales.map(locale => {
    const trimmedLocale = locale.trim();
    return opt.languageCodeOnly
      ? trimmedLocale.split(/-|_/)[0]
      : trimmedLocale;
  });
}